<!-- Page Header -->
<div class="mb-6 px-3">
  <div>
    <div class="w-full rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3 sm:w-fit">
      <div class="border-l-4 border-slate-900 pl-4">
        <p class="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">
          Manage Preview
        </p>

        <h2 class="mt-1 text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">
          Facebook Photo Post
        </h2>
      </div>
    </div>
  </div>
</div>

<!-- Main Layout -->
<div class="mx-auto grid w-full max-w-7xl grid-cols-1 items-start gap-6 px-3 sm:px-6 lg:px-50 xl:grid-cols-[50%_50%] xl:gap-10">

  <!-- Preview Column -->
  <div class="relative w-full max-w-2xl justify-self-center xl:justify-self-start">

    <!-- Floating Desktop Actions -->
    <div class="absolute top-4 z-20 hidden -left-14 flex-col items-center rounded-3xl border border-gray-300 bg-white/95 px-2 py-3 backdrop-blur-md xl:flex 2xl:-left-20">

      <app-manage-preview-action-button
        icon="arrow_back"
        tooltip="Back"
        buttonClass="my-1 bg-slate-100 text-slate-700 transition hover:bg-slate-200 hover:text-slate-950 focus:outline-none focus:ring-2 focus:ring-blue-100"
        (actionClick)="goBack()"
      ></app-manage-preview-action-button>

      <app-manage-preview-action-button
        icon="edit"
        tooltip="Edit"
        [disabled]="true"
        buttonClass="my-1 bg-slate-100 text-slate-400"
      ></app-manage-preview-action-button>

      <app-manage-preview-action-button
        icon="replay"
        tooltip="Reuse"
        buttonClass="my-1 bg-slate-100 text-slate-700 transition hover:bg-slate-200 hover:text-slate-950 focus:outline-none focus:ring-2 focus:ring-blue-100"
        (actionClick)="reusePost()"
      ></app-manage-preview-action-button>

      <app-manage-preview-action-button
        icon="delete_outline"
        tooltip="Delete"
        tooltipPosition="left"
        [disabled]="true"
        buttonClass="my-1 bg-slate-100 text-slate-400"
      ></app-manage-preview-action-button>

      <div class="my-3 h-px w-8 bg-slate-200"></div>

      <app-manage-preview-action-button
        icon="skip_previous"
        tooltip="Previous"
        buttonClass="my-1 bg-slate-100 text-slate-700 transition hover:bg-slate-200 hover:text-slate-950 focus:outline-none focus:ring-2 focus:ring-blue-100"
        (actionClick)="goToPreviousPost()"
      ></app-manage-preview-action-button>

      <app-manage-preview-action-button
        icon="skip_next"
        tooltip="Next"
        buttonClass="my-1 bg-slate-100 text-slate-700 transition hover:bg-slate-200 hover:text-slate-950 focus:outline-none focus:ring-2 focus:ring-blue-100"
        (actionClick)="goToNextPost()"
      ></app-manage-preview-action-button>

    </div>

    <!-- Mobile / Tablet Actions -->
    <div class="mb-4 grid grid-cols-6 gap-2 rounded-3xl border border-gray-300 bg-white/95 p-3 backdrop-blur-md xl:hidden">

      <app-manage-preview-action-button
        icon="arrow_back"
        tooltip="Back"
        buttonClass="bg-slate-100 text-slate-700 transition hover:bg-slate-200 hover:text-slate-950"
        (actionClick)="goBack()"
      ></app-manage-preview-action-button>

      <app-manage-preview-action-button
        icon="edit"
        tooltip="Edit"
        [disabled]="true"
        buttonClass="bg-slate-100 text-slate-400"
      ></app-manage-preview-action-button>

      <app-manage-preview-action-button
        icon="replay"
        tooltip="Reuse"
        buttonClass="bg-slate-100 text-slate-700 transition hover:bg-slate-200 hover:text-slate-950"
        (actionClick)="reusePost()"
      ></app-manage-preview-action-button>

      <app-manage-preview-action-button
        icon="delete_outline"
        tooltip="Delete"
        [disabled]="true"
        buttonClass="bg-slate-100 text-slate-400"
      ></app-manage-preview-action-button>

      <app-manage-preview-action-button
        icon="skip_previous"
        tooltip="Previous"
        buttonClass="bg-slate-100 text-slate-700 transition hover:bg-slate-200 hover:text-slate-950"
        (actionClick)="goToPreviousPost()"
      ></app-manage-preview-action-button>

      <app-manage-preview-action-button
        icon="skip_next"
        tooltip="Next"
        buttonClass="bg-slate-100 text-slate-700 transition hover:bg-slate-200 hover:text-slate-950"
        (actionClick)="goToNextPost()"
      ></app-manage-preview-action-button>

    </div>

    <!-- Facebook Card -->
    <div class="facebook-card hidden w-full max-w-2xl overflow-hidden rounded-3xl border border-gray-300 bg-white">

      <div class="card-body px-0 py-0">

        <!-- Header -->
        <div class="grid grid-cols-7 gap-3 px-4 py-4 sm:gap-4 sm:px-5">
          <div class="col-span-6 min-w-0">
            <div class="flex min-w-0 items-center gap-3">
              <img
                [src]="thumbnailFilePath"
                class="user-avatar h-10 w-10 shrink-0 rounded-full border border-gray-300 object-cover sm:h-11 sm:w-11"
                alt="User Avatar"
              />

              <div class="min-w-0">
                <p class="mb-0 truncate font-15 text-sm font-semibold text-slate-950 bold-600">
                  {{ postFeed }}
                </p>

                <small class="text-muted mt-0.5 flex min-w-0 items-center text-xs font-medium text-slate-500">
                  <span class="truncate">{{ formattedDate }} - &nbsp;</span>

                  <img
                    src="assets/icons/world.png"
                    class="world-icon me-2 h-3.5 w-3.5 shrink-0 opacity-70"
                    alt="World Icon"
                  />
                </small>
              </div>
            </div>
          </div>

          <div class="col-span-1 flex items-start justify-end">
            <button
              type="button"
              class="rounded-full p-2 transition hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-blue-100"
            >
              <img
                src="assets/icons/dots.png"
                class="dots-icon h-5 w-5 cursor-pointer rounded-full opacity-80"
                alt="Dots Icon"
              />
            </button>
          </div>
        </div>

        <!-- Post Content -->
        <div class="post-description px-4 pb-4 sm:px-5" [attr.dir]="textDirection">
          <p class="mb-0 whitespace-pre-line break-words text-sm leading-6 text-slate-800 sm:text-[15px]">
            {{ postDescription }}

            <span
              class="text-muted font-semibold text-slate-500"
              *ngIf="totChars > 250 && socialTag !== 'fbfirstcomment'"
            >
              &nbsp; View more
            </span>

            <span
              class="text-muted inline-flex items-center gap-1 font-semibold text-slate-500"
              *ngIf="socialTag === 'fbfirstcomment'"
            >
              <img
                src="assets/icons/link-icon.png"
                class="facebook-like-icon ms-0 -mt-1 inline h-4 w-4"
                alt="Link Icon"
              />
              Link in first comment
            </span>
          </p>
        </div>

        <!-- Photo Post Image: Generated Publio Preview -->
        <div *ngIf="switchboardImage === 0">
          <div
            class="facebook-image-container relative mb-3 flex h-[320px] items-center justify-center overflow-hidden bg-slate-100 sm:h-[460px] md:h-[560px] xl:h-[700px]"
            *ngIf="socialTag !== 'photolink'"
          >
            <img
              [src]="mainImageUrl"
              alt="Facebook photo post image"
              class="h-full w-full object-cover"
            />

            <!-- Caption Overlay -->
            <div class="image-container-content absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/85 via-black/50 to-transparent px-4 pb-6 pt-20 text-center sm:px-8 sm:pb-9 sm:pt-24">
              <h3 class="image-caption mx-auto mt-3 max-w-xl px-2 text-lg font-bold leading-tight text-white sm:text-2xl">
                {{ postTitle }}
              </h3>

              <hr class="mx-auto my-4 h-1 w-16 rounded-full border-t-0 bg-white/80 opacity-100" />

              <p class="mb-0 text-xs font-medium text-white/90 bold-500 sm:text-base">
                This is a preview image provided by <em>Publio.ai</em>
              </p>
            </div>
          </div>
        </div>

        <!-- Photo Post Image: Switchboard Image -->
        <div *ngIf="switchboardImage === 1">
          <div
            class="facebook-image-container mb-3 flex items-center justify-center overflow-hidden bg-slate-100"
            *ngIf="socialTag !== 'photolink'"
          >
            <img
              [src]="mainImageUrl"
              alt="Facebook photo post image"
              class="max-h-[320px] w-full object-contain sm:max-h-[560px] xl:max-h-[750px]"
            />
          </div>
        </div>

        <!-- Optional Photolink Fallback -->
        <div
          *ngIf="socialTag === 'photolink'"
          class="photolink-container flex h-full items-center justify-center overflow-hidden bg-slate-100"
        >
          <img
            [src]="mainImageUrl ? mainImageUrl : './assets/images/na.png'"
            alt="Facebook photolink image"
            class="w-100 mx-auto w-full object-contain"
          />
        </div>

        <div
          class="post-title border-y border-gray-300 bg-slate-50/70 px-4 py-4 sm:px-5"
          *ngIf="socialTag === 'photolink'"
        >
          <p class="mb-1">
            <span class="font-16 text-muted text-xs font-semibold uppercase tracking-wide text-slate-500">
              {{ siteDomain }}
            </span>
          </p>

          <p class="mt-2 mb-0">
            <span class="font-15 text-base font-semibold leading-snug text-slate-950 bold-600">
              {{ postTitle }}
            </span>
          </p>
        </div>

        <!-- Likes, Comments, Shares -->
        <div class="px-4 pt-3 pb-3 sm:px-5">
          <div class="grid grid-cols-1 gap-3 text-sm text-slate-500 sm:grid-cols-2 sm:items-center">
            <div class="flex items-center">
              <img
                src="assets/icons/facebook-like.png"
                class="facebook-like-icon h-5 w-5"
                alt="Like Image"
              />

              <img
                src="assets/icons/facebook-heart.png"
                class="facebook-like-icon ms-0 -ml-1 h-5 w-5"
                alt="Heart Image"
              />

              <span class="ms-1 font-medium">#</span>
            </div>

            <div class="text-muted flex items-center justify-start gap-3 font-medium sm:justify-end">
              <span># comments</span>
              <span># shares</span>
            </div>
          </div>
        </div>

        <!-- Divider -->
        <div class="px-4 sm:px-5">
          <hr class="border-t border-gray-300" />
        </div>

        <!-- Engagement Buttons -->
        <div class="social-text grid grid-cols-3 gap-1 px-2 py-2 sm:gap-2 sm:px-4">
          <button class="flex items-center justify-center gap-1 rounded-xl px-2 py-2.5 text-xs font-semibold text-slate-600 transition hover:bg-slate-100 hover:text-slate-950 focus:outline-none focus:ring-2 focus:ring-blue-100 sm:gap-2 sm:px-3 sm:text-sm">
            <img
              src="assets/icons/like.png"
              class="facebook-like-icon h-4 w-4"
              alt="Like Image"
            />
            <span>Like!</span>
          </button>

          <button class="flex items-center justify-center gap-1 rounded-xl px-2 py-2.5 text-xs font-semibold text-slate-600 transition hover:bg-slate-100 hover:text-slate-950 focus:outline-none focus:ring-2 focus:ring-blue-100 sm:gap-2 sm:px-3 sm:text-sm">
            <img
              src="assets/icons/comment.png"
              class="facebook-like-icon h-4 w-4"
              alt="Comment Image"
            />
            <span>Comment</span>
          </button>

          <button class="flex items-center justify-center gap-1 rounded-xl px-2 py-2.5 text-xs font-semibold text-slate-600 transition hover:bg-slate-100 hover:text-slate-950 focus:outline-none focus:ring-2 focus:ring-blue-100 sm:gap-2 sm:px-3 sm:text-sm">
            <img
              src="assets/icons/share.png"
              class="facebook-like-icon h-4 w-4"
              alt="Share Image"
            />
            <span>Share</span>
          </button>
        </div>

      </div>
    </div>

  </div>

  <!-- Right Sidebar -->
  <div class="grid w-full max-w-2xl gap-5 justify-self-center xl:max-w-none xl:justify-self-stretch">

    <!-- Latest Posts -->
    <app-manage-preview-latest-posts
      [posts]="latestPosts"
      (postClick)="openLatestPost($event)"
    ></app-manage-preview-latest-posts>

    <!-- Latest Alerts -->
    <app-manage-preview-latest-alerts
      [alerts]="latestAlerts"
      (alertClick)="openLatestPost($event)"
    ></app-manage-preview-latest-alerts>

  </div>

</div>